import { render } from "./NaviBar.vue?vue&type=template&id=7081fecc"
import script from "./NaviBar.vue?vue&type=script&lang=js"
export * from "./NaviBar.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src822836300/src/awsmng/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__